import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const SelectionsContext = createContext(null);

export const SelectionsProvider = ({children}) => {
    const { auth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [selectedOrgID, setSelectedOrgID] = useState('');
    const [selectedSiteID, setSelectedSiteID] = useState('');
    const [selectedTabName, setSelectedTabName] = useState(''); 

    useEffect(() => {
        const m = location.pathname.match(/^\/sites\/(\d+)/);
        if (m) {
            const id = Number(m[1]);
            if (!Number.isNaN(id) && id !== Number(selectedSiteID)) {
            setSelectedSiteID(id);
            }
        }
    }, [location.pathname]);

    useEffect(() => {
        const role = auth?.role;
        const isInternal = role === process.env.REACT_APP_ES_ADMIN || role === process.env.REACT_APP_ES_USER;

        if (!auth?.accessToken || !isInternal) {
            setSelectedOrgID('');
            setSelectedSiteID('');
            setSelectedTabName('');
        }
    }, [auth?.accessToken, auth?.role]);

    useEffect(() => {
        if (!selectedTabName || !selectedSiteID) return;

        let target = '';
        if(selectedTabName === 'properties'){
            target = `/client/${selectedOrgID}`;
        }else if(selectedTabName === 'admin-tables'){
            target = '/admin-tables';
        }else{
            target = `/sites/${selectedSiteID}`;
        }

        navigate(target, {
            // replace: true,
            state: { tab: selectedTabName, _ts: Date.now() },
        });

        setSelectedTabName('');
    }, [selectedTabName, selectedSiteID, selectedOrgID, navigate]);

    const value = useMemo(() => ({
        selectedOrgID, setSelectedOrgID,
        selectedSiteID, setSelectedSiteID,
        selectedTabName, setSelectedTabName,
    }), [selectedOrgID, selectedSiteID, selectedTabName]);

    return <SelectionsContext.Provider value={value}>{children}</SelectionsContext.Provider>;
}

export const useSelections = () => {
    const ctx = useContext(SelectionsContext);
    if (!ctx) throw new Error('useSelections must be used within <SelectionsProvider>');
    return ctx;
}
